import type { AutomationStatusType } from "@/types/graphql/partner.generated";

/** Чем закончился диалог автоматизации для списка под ним. */
export interface AutomationDialogOutcome {
  /** Статус при закрытии отличается от статуса при открытии. */
  statusChanged: boolean;
}

export const NO_OUTCOME: AutomationDialogOutcome = { statusChanged: false };

/** Статус автоматизации сменился за время диалога (запуск или пауза). */
export const statusChanged = (
  opened: AutomationStatusType | null,
  current: AutomationStatusType | null
): boolean => opened !== null && current !== null && opened !== current;

/**
 * Перечитать список после диалога (супер-ревью 2): строка сама обновляется
 * ответом мутации в кеше, но из списка, отфильтрованного по статусу,
 * запущенная или поставленная на паузу автоматизация должна выпасть (или
 * в нём появиться). Только этот случай стоит одного запроса списка.
 */
export const listRefetchOnClose = (
  statusFilter: AutomationStatusType | undefined,
  outcome: AutomationDialogOutcome
): boolean => Boolean(statusFilter) && outcome.statusChanged;
